import React, { Component } from "react";
import { connect } from 'react-redux';
import { isChrome, isFirefox, isOpera, isIE } from 'react-device-detect';

import { clear_states } from '../states/action';
import ParsicHeader from "./ParsicHeader";
import Shortlink_instruction from "./Shortlink_Instruction";
import Shortlink_operation from "./Shortlink_Operation";
import ShortLink_Redirection from "./ShortLink_Redirection";
import HomePage from "./HomePage";


import { Container, Row, Col } from 'reactstrap';


import 'bootstrap/dist/css/bootstrap.css';
import '../Styles/ShortLinkMainLayout.css';
import '../Styles/shared.css';
import ParsicFooter from "./ParsicFooter";
import Button from "reactstrap/lib/Button";



class ShortLinkMainLayout extends Component {

    state = { shortlink: null, operationalmode: false };

    constructor(props) {
        super(props);
    }

    componentDidMount() {

        const { parameter1 } = this.props.match.params;

        console.log(parameter1);

        if (parameter1 == null) {
          this.setState({ shortlink: null, operationalmode: false })
          window.location.href = "http://www.home.pws.ir";
        }
        else {
            this.setState({ shortlink: parameter1, operationalmode: true })
        }
        // console.log("componentDidMount");
        // console.log(this.props);
    }


    render() {

        let content = this.state.operationalmode
            ?
            (
                (isIE == true)
                    ?
                    (
                        <div className="mt-2 content-center content-text-center">
                            <div className="content-center">مرورگر اینترنت اکسپلورر پشتیبانی نمی شود لطفا از یکی از مرورگرهای زیر استفاده نمایید</div>
                            <div className="mt-1 content-text-center">
                                <a href="https://www.mozilla.org/en-GB/firefox/new/" target="_blank"><img className="img-fluid rounded-circle border Incompatible-Warning-logo content-center" src='./Assets/firefox.png' alt="Firefox" ></img></a>
                                <a href="https://www.google.com/intl/en_uk/chrome/" target="_blank"><img className="img-fluid rounded-circle border Incompatible-Warning-logo content-center" src='./Assets/chrome.png' alt="Chrome"></img></a>
                            </div>
                        </div>
                    )
                    :
                    (
                        <Container className="custom-container shadow p-2 mt-3 mb-5 bg-white rounded border bg-primary">
                            <Row>
                                <Col sm="6" md="6" lg="6" xl="6"><Shortlink_operation shortlink={this.state.shortlink}></Shortlink_operation></Col>
                                <Col sm="6" md="6" lg="6" xl="6"><Shortlink_instruction></Shortlink_instruction></Col>
                            </Row>
                        </Container>
                    )
            )
            :
            (
                // <Container className="shadow p-2 mt-3 mb-5 bg-white rounded border bg-primary">
                <HomePage></HomePage>
                // </Container>
            )

        let overlaycontent = this.props.UserAuthPass && this.state.operationalmode
            ?
            (
                <ShortLink_Redirection></ShortLink_Redirection>
            )
            :
            (
                <div>
                    <ParsicHeader></ParsicHeader>
                    <div> {content}</div>
                    <ParsicFooter></ParsicFooter>
                </div>
            )


        return (

            <div>
                {overlaycontent}
            </div>

        )
    }

}

const mapStateToProps = state => {
    const Mylink = state.Mylink;
    const UserAuthPass = state.UserAuthPass;
    return { Mylink, UserAuthPass }
};

export default connect(mapStateToProps)(ShortLinkMainLayout)
// export default ShortLinkMainLayout